// @ts-nocheck
import React from "react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui";

export const CatalogTab = ({ d }) => (
  <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Catalog Summary</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <div className="p-3 rounded-lg bg-slate-50 dark:bg-slate-800/50">
            <p className="text-2xl font-bold text-slate-900 dark:text-slate-100">
              {d.catalogSummary.totalSKUs.toLocaleString()}
            </p>
            <p className="text-xs text-slate-500 dark:text-slate-400">
              Total SKUs
            </p>
          </div>
          <div className="p-3 rounded-lg bg-slate-50 dark:bg-slate-800/50">
            <p className="text-2xl font-bold text-amber-600 dark:text-amber-400">
              {d.catalogSummary.needsMapping}
            </p>
            <p className="text-xs text-slate-500 dark:text-slate-400">
              Needs Mapping
            </p>
          </div>
          <div className="p-3 rounded-lg bg-slate-50 dark:bg-slate-800/50">
            <p className="text-2xl font-bold text-emerald-600 dark:text-emerald-400">
              {d.catalogSummary.recentlyUpdated}
            </p>
            <p className="text-xs text-slate-500 dark:text-slate-400">
              Recently Updated
            </p>
          </div>
          <div className="p-3 rounded-lg bg-slate-50 dark:bg-slate-800/50">
            <p className="text-2xl font-bold text-indigo-600 dark:text-indigo-400">
              {d.catalogSummary.productTypes.length}
            </p>
            <p className="text-xs text-slate-500 dark:text-slate-400">
              Product Types
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Product Type Distribution</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          {d.catalogSummary.productTypes.map((pt) => {
            const pct = Math.round(
              (pt.count / d.catalogSummary.totalSKUs) * 100,
            );
            return (
              <div key={pt.type} className="flex items-center gap-3">
                <span className="text-sm text-slate-700 dark:text-slate-300 w-32 truncate">
                  {pt.type}
                </span>
                <div className="flex-1 h-3 bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden">
                  <div
                    className="h-full bg-indigo-500 rounded-full"
                    style={{ width: `${pct}%` }}
                  />
                </div>
                <span className="text-xs text-slate-500 dark:text-slate-400 w-16 text-right">
                  {pt.count.toLocaleString()}
                </span>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  </div>
);
